import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_u6qmzkb6y9: FaireBrandEntity = {
  token: "b_u6qmzkb6y9",
  type: "brand",
  name: "in february",
  avatarUrl:
    "https://cdn.faire.com/fastly/50147a35a58b006d1fb64be9c9778481fbb07eea84cc6a056b4ee325f3cc5de8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/b075d28dba086bada84b72137a2df0cd1f9afa87c600f79797d4a5c372649d6a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/50147a35a58b006d1fb64be9c9778481fbb07eea84cc6a056b4ee325f3cc5de8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b075d28dba086bada84b72137a2df0cd1f9afa87c600f79797d4a5c372649d6a.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 40,
  rating: 4.9,
  reviewCount: 198,
  isTopShop: true,
  isInsider: true,
  description:
    'Welcome to in february, purveyors of modern serenity, style, and effortless elegance. Our unique, soft approach to fearless design knows no bounds, and we strive every day to create something truly unique, sophisticated, and sensational. \n\nAt our core, in february is a clothing line that truly embodies the essence of femininity. We\'re a team of dreamers and doers who are dedicated to delivering stunning pieces of wearable art that celebrate and elevate women. Our designs are an extension of our personalities, mirroring our uniqueness, openness, power, and penchant for logic. We are "in february".',
  meta: {
    source: "api",
    importedAt: "2026-08-18T17:20:33.605Z",
    importedBy: "entity-db-cli",
  },
};
